"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.colorSelector = void 0;

var _escapeCss = require("../../escapeCss");

var colorSelector = function colorSelector(props, color, intensity) {
  var _props$theme, _props$theme$colors, _props$theme$colors$c;

  return (0, _escapeCss.escapeCss)((_props$theme = props.theme) === null || _props$theme === void 0 ? void 0 : (_props$theme$colors = _props$theme.colors) === null || _props$theme$colors === void 0 ? void 0 : (_props$theme$colors$c = _props$theme$colors[color]) === null || _props$theme$colors$c === void 0 ? void 0 : _props$theme$colors$c["$".concat(String(intensity).padStart(3, "0"))]);
};

exports.colorSelector = colorSelector;